/**
 * Created by matheusmorett on 22/08/17.
 */
import Newsletter from './Newsletter';
export default Newsletter;